import { render } from "./UserGroupsModal.vue?vue&type=template&id=7930f549&scoped=true"
import script from "./UserGroupsModal.vue?vue&type=script&lang=js"
export * from "./UserGroupsModal.vue?vue&type=script&lang=js"

import "./UserGroupsModal.vue?vue&type=style&index=0&id=7930f549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7930f549"]])

export default __exports__